export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  categories: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapterCount: number;
  latestChapter: string;
  updatedAt: string;
  featured: boolean;
  hot: boolean;
  newRelease: boolean;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑尊归来',
    author: 'Redice Studio',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20style%20illustration%20featuring%20a%20powerful%20martial%20artist%20holding%20a%20glowing%20sword%20with%20intense%20expression%2C%20dark%20fantasy%20background%20with%20red%20energy%20effects%2C%20clean%20lines%2C%20vibrant%20colors%2C%20simple%20gradient%20background%2C%20character-focused%20portrait%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    categories: ['cat-1', 'cat-3', 'cat-8'],
    description: '一代剑尊陨落后重生回到少年时代，带着前世的记忆与剑术，他誓要改变命运，手刃仇敌，重登剑道巅峰。前世今生的恩怨纠葛，热血激昂的剑术对决，一段传奇就此展开。',
    status: '连载中',
    rating: 9.6,
    views: 12800000,
    chapterCount: 156,
    latestChapter: '第156话 - 剑指苍穹',
    updatedAt: '2026-07-08',
    featured: true,
    hot: true,
    newRelease: false,
    tags: ['重生', '热血', '玄幻', '战斗'],
  },
  {
    id: 'comic-2',
    title: '甜蜜的谎言',
    author: 'Carrotoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20beautiful%20couple%20embracing%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20clean%20lines%2C%20simple%20pastel%20background%2C%20character-focused%20portrait%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    categories: ['cat-2', 'cat-4'],
    description: '为了还清父亲的债务，她答应假扮财阀继承人的未婚妻三个月。本以为是各取所需的交易，却在朝夕相处中渐渐沦陷。当真相浮出水面，这份始于谎言的感情，能否走向真实的幸福？',
    status: '连载中',
    rating: 9.3,
    views: 15600000,
    chapterCount: 98,
    latestChapter: '第98话 - 无法隐藏的心意',
    updatedAt: '2026-07-07',
    featured: true,
    hot: true,
    newRelease: false,
    tags: ['恋爱', '契约婚姻', '财阀', '甜宠'],
  },
  {
    id: 'comic-3',
    title: '暗夜猎人',
    author: 'Studio JHS',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20mysterious%20hunter%20in%20black%20coat%20holding%20a%20silver%20dagger%2C%20moonlit%20night%20scene%2C%20gothic%20atmosphere%2C%20cool%20blue%20and%20silver%20tones%2C%20clean%20lines%2C%20character-focused%20portrait&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    categories: ['cat-3', 'cat-5', 'cat-7'],
    description: '在怪物横行的末日世界里，他是最顶级的暗夜猎人。拥有窥见怪物弱点的特殊能力，每一次猎杀都在死亡的边缘游走。而当最大的阴谋浮出水面，他发现自己才是那个被猎杀的目标。',
    status: '连载中',
    rating: 9.5,
    views: 10200000,
    chapterCount: 134,
    latestChapter: '第134话 - 深渊来客',
    updatedAt: '2026-07-08',
    featured: true,
    hot: true,
    newRelease: false,
    tags: ['末日', '奇幻', '悬疑', '战斗'],
  },
  {
    id: 'comic-4',
    title: '办公室罗曼史',
    author: 'Kidari Studio',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20romance%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20handsome%20CEO%20and%20a%20professional%20woman%20in%20office%20attire%2C%20warm%20lighting%2C%20elegant%20city%20backdrop%2C%20clean%20lines%2C%20pastel%20warm%20tones%2C%20character-focused%20portrait%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    categories: ['cat-2', 'cat-4'],
    description: '新入职的小职员不知道自己的顶头上司就是大学时暗恋的学长。冰冷外表下的温柔，专业面具后的深情，一栋写字楼里的心跳加速恋爱故事。谁先动心，谁就输了。',
    status: '已完结',
    rating: 9.1,
    views: 18900000,
    chapterCount: 87,
    latestChapter: '第87话 - 大结局：余生请多指教',
    updatedAt: '2026-06-15',
    featured: false,
    hot: true,
    newRelease: false,
    tags: ['恋爱', '职场', '暗恋', '甜宠'],
  },
  {
    id: 'comic-5',
    title: '修仙模拟器',
    author: 'Turtle Studio',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20cultivation%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20cultivator%20surrounded%20by%20floating%20magical%20runes%20and%20spirit%20energy%2C%20ancient%20Chinese%20inspired%20setting%2C%20golden%20and%20jade%20green%20tones%2C%20clean%20lines%2C%20character-focused%20portrait&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    categories: ['cat-3', 'cat-6', 'cat-8'],
    description: '普通大学生意外获得修仙模拟器系统，从此踏上修仙之路。打怪升级、炼丹炼器、收服神兽，在搞笑与热血中不断突破境界。本想低调修仙，却一不小心成了三界最强。',
    status: '连载中',
    rating: 9.4,
    views: 9500000,
    chapterCount: 210,
    latestChapter: '第210话 - 渡劫成功',
    updatedAt: '2026-07-08',
    featured: false,
    hot: true,
    newRelease: true,
    tags: ['修仙', '系统', '搞笑', '热血'],
  },
  {
    id: 'comic-6',
    title: '深渊之眼',
    author: 'YLAB',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20psychological%20thriller%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20detective%20with%20piercing%20eyes%2C%20dark%20alley%20background%20with%20shadows%2C%20mysterious%20atmosphere%2C%20muted%20dark%20tones%20with%20red%20accents%2C%20clean%20lines%2C%20character-focused%20portrait&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    categories: ['cat-5', 'cat-7'],
    description: '一位拥有特殊能力的刑警，能够通过触碰尸体看到死者最后七秒的记忆。连环杀人案、神秘符号、隐藏在城市暗处的罪恶，真相远比想象中更加可怕。',
    status: '已完结',
    rating: 9.7,
    views: 13500000,
    chapterCount: 62,
    latestChapter: '第62话 - 终章：真相大白',
    updatedAt: '2026-05-20',
    featured: true,
    hot: false,
    newRelease: false,
    tags: ['悬疑', '推理', '犯罪', '超能力'],
  },
  {
    id: 'comic-7',
    title: '异世界餐厅',
    author: 'Naver Webtoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20fantasy%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20cheerful%20chef%20in%20a%20magical%20restaurant%20with%20fantasy%20creatures%20as%20customers%2C%20warm%20golden%20lighting%2C%20whimsical%20atmosphere%2C%20clean%20lines%2C%20vibrant%20food%20colors%2C%20character-focused%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    categories: ['cat-3', 'cat-6'],
    description: '普通人穿越到异世界，没有战斗天赋，只有一手好厨艺。用美食征服各族食客，用真诚结交各路朋友。在这个剑与魔法的世界，开一家治愈人心的餐厅。',
    status: '连载中',
    rating: 9.2,
    views: 8700000,
    chapterCount: 145,
    latestChapter: '第145话 - 龙族的味蕾',
    updatedAt: '2026-07-06',
    featured: false,
    hot: false,
    newRelease: true,
    tags: ['美食', '穿越', '治愈', '奇幻'],
  },
  {
    id: 'comic-8',
    title: '九尾狐传',
    author: 'Jaedam',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20mysterious%20nine-tailed%20fox%20spirit%20in%20human%20form%2C%20ancient%20Korean%20palace%20background%2C%20ethereal%20white%20and%20gold%20tones%2C%20clean%20lines%2C%20elegant%20traditional%20aesthetic%2C%20character-focused%20portrait&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    categories: ['cat-3', 'cat-8', 'cat-2'],
    description: '修炼千年的九尾狐化为人形，在现代都市中寻找失散的族人。一场意外的相遇，让她与命中注定的那个人重逢。前世今生的羁绊，跨越千年的爱恋，九尾狐的传奇故事。',
    status: '连载中',
    rating: 9.4,
    views: 11300000,
    chapterCount: 89,
    latestChapter: '第89话 - 千年之约',
    updatedAt: '2026-07-05',
    featured: false,
    hot: true,
    newRelease: false,
    tags: ['玄幻', '古风', '恋爱', '转世'],
  },
  {
    id: 'comic-9',
    title: '电竞之王',
    author: 'Toyou\'s Dream',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20esports%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20pro%20gamer%20with%20headset%2C%20neon%20gaming%20arena%20background%2C%20energetic%20cyberpunk%20vibe%2C%20bright%20neon%20accents%2C%20clean%20lines%2C%20character-focused%20action%20portrait&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    categories: ['cat-1', 'cat-4'],
    description: '被战队抛弃的天才选手，从零开始组建草根战队。招募各路高手，突破重重阻碍，目标只有一个——世界冠军。电竞不只是游戏，是青春和梦想！',
    status: '连载中',
    rating: 9.3,
    views: 7200000,
    chapterCount: 178,
    latestChapter: '第178话 - 总决赛',
    updatedAt: '2026-07-07',
    featured: false,
    hot: false,
    newRelease: true,
    tags: ['电竞', '热血', '竞技', '青春'],
  },
  {
    id: 'comic-10',
    title: '社长的小娇妻',
    author: 'Kakao Webtoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20cute%20couple%20in%20wedding%20attire%2C%20sparkling%20romantic%20background%20with%20flowers%2C%20soft%20pink%20and%20cream%20tones%2C%20clean%20lines%2C%20dreamy%20atmosphere%2C%20character-focused%20portrait&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    categories: ['cat-2', 'cat-4', 'cat-10'],
    description: '被家族安排联姻的小职员，嫁给了冷酷无情的商业社长。原以为是无爱的政治婚姻，却发现冷漠面具下藏着一颗只对她温柔的心。先婚后爱，甜到发齁。',
    status: '已完结',
    rating: 9.0,
    views: 20100000,
    chapterCount: 72,
    latestChapter: '第72话 - 大结局：此生挚爱',
    updatedAt: '2026-04-30',
    featured: false,
    hot: false,
    newRelease: false,
    tags: ['恋爱', '先婚后爱', '霸总', '甜宠'],
  },
  {
    id: 'comic-11',
    title: '末日生存指南',
    author: 'D&C Webtoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20survivor%20with%20weapons%20in%20a%20ruined%20cityscape%2C%20dramatic%20orange%20sky%2C%20intense%20survival%20atmosphere%2C%20muted%20earth%20tones%2C%20clean%20lines%2C%20character-focused%20action%20portrait&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    categories: ['cat-1', 'cat-5', 'cat-7'],
    description: '丧尸病毒爆发，世界陷入混乱。退伍特种兵李浩凭借着过人的战斗技巧和生存经验，在末日废土中保护幸存者，寻找希望的曙光。',
    status: '连载中',
    rating: 9.1,
    views: 6800000,
    chapterCount: 93,
    latestChapter: '第93话 - 安全区',
    updatedAt: '2026-07-04',
    featured: false,
    hot: false,
    newRelease: false,
    tags: ['末日', '丧尸', '生存', '热血'],
  },
  {
    id: 'comic-12',
    title: '校园异能社',
    author: 'Lezhin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20youthful%20school%20life%20Korean%20manhwa%20cover%20style%20illustration%20of%20students%20with%20superpowers%20in%20school%20uniforms%2C%20vibrant%20school%20campus%20background%2C%20bright%20colorful%20tones%2C%20clean%20lines%2C%20energetic%20youthful%20atmosphere%2C%20group%20character%20portrait&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    categories: ['cat-1', 'cat-3', 'cat-6'],
    description: '看似普通的校园里隐藏着超能力者社团。拥有不同异能的少男少女们，在日常与危机中成长，守护校园和平。青春异能物语，热血与搞笑并存。',
    status: '连载中',
    rating: 9.0,
    views: 5400000,
    chapterCount: 121,
    latestChapter: '第121话 - 觉醒',
    updatedAt: '2026-07-06',
    featured: false,
    hot: false,
    newRelease: true,
    tags: ['校园', '超能力', '搞笑', '青春'],
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(categoryId: string): Comic[] {
  return comics.filter((c) => c.categories.includes(categoryId));
}

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.featured);
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.hot);
}

export function getNewReleases(): Comic[] {
  return comics.filter((c) => c.newRelease);
}

export function getRelatedComics(comic: Comic, limit: number = 5): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && c.categories.some((cat) => comic.categories.includes(cat)))
    .slice(0, limit);
}